import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue-with-blue.svg';
import { Modal } from 'components';
import { Button } from 'antd';

const WarningModal = props => {
  let {
    isVisible,
    setVisible,
    width=450,
    title = 'Ανεπιτυχής Υποβολή',
    message = 'Παρουσιάστηκε σφάλμα κατά τη διαδικασία της υποβολής. Η υποβολή δεν ολοκληρώθηκε.',
    warningKey = "default",
  } = props;

  let Icon = WarningRed;

  if (warningKey === "excel-text-format") {
    title = "Προσοχή";
    message = `Παρακαλούμε βεβαιωθείτε ότι όλα τα κελιά στο αρχείο Excel έχουν μορφοποίηση "Κείμενο" (Format Cell: Text), για την επιτυχή ολοκλήρωση της μεταφόρτωσης.`;
    Icon = WarningBlue;
  }
  
  return (
    <Modal
      isVisible={isVisible}
      // Icon={icon}
      closable={true}
      //   title={title}
      // handleConfirm={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={width}
      footer={
        [
          <Button
            type={'default'}
            style={{width: '100%'}}
            onClick={() => setVisible(false)}
          >Κλείσιμο</Button>,
        ]
      }
      className={'invalid-modal custom-modal warning-modal'}
    >
      <div className="custom-modal__header"><Icon/><span>{title}</span></div>
      <div className="custom-modal__body">{message}</div>
    </Modal>
  );
};

export default WarningModal;
